module.exports = "/images/sac-cuir.png?8c2df0767424863ed85a4863b3a13e4e";